import type { TFunction } from "i18next"

type ApiErrorLike = {
  error?: string
  message?: string
}

/**
 * Traduz um erro da API usando o código de negócio como chave i18n.
 *
 * O backend deve retornar o código em `error` (ex: "INVALID_OF_AGE") e uma
 * mensagem padrão em `message`. O front mantém o catálogo traduzido sob
 * `apiErrors.<code>` e usa a mensagem do backend como fallback quando a chave
 * ainda não existe no locale ativo.
 */
export const translateApiError = (
  t: TFunction,
  error: ApiErrorLike,
  fallback: string
): string => {
  if (!error.error) {
    return error.message || fallback
  }

  return t(`apiErrors.${error.error}`, {
    defaultValue: error.message || fallback,
  })
}

/**
 * Traduz uma lista de erros da API, unindo as mensagens.
 */
export const translateApiErrors = (
  t: TFunction,
  errors: ApiErrorLike[] | undefined,
  fallback: string
): string => {
  const translated = errors
    ?.map((err) => translateApiError(t, err, ""))
    .filter(Boolean)
    .join(", ")

  return translated || fallback
}
